// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dna-card_wrapper__Qq4kb","textWrapper":"dna-card_textWrapper__y_MX1","title":"dna-card_title__jmgYy","description":"dna-card_description__H03r8"};